module.exports = __webpack_public_path__ + "static/media/08 Perete CK65 - Galben.30f9deaa.jpg";